import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactApexChart from 'react-apexcharts'
import { Link } from 'react-router-dom'
import { avatar1, avatar2, avatar3, avatar4, avatar6, avatar7, avatar8, avatar9, userProfile } from '../../assets/images'
import { IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin, IconBrandTwitter } from '@tabler/icons-react'

export default function ClientDetail() {

    const chartData1 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color1)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                categories: [1, 2, 3, 4, 5, 6, 7, 8],
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 50,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [40, 10, 30, 15, 12, 25, 15, 40]
            }
        ]
    };

    const chartData2 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color2)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                categories: [1, 2, 3, 4, 5, 6, 7, 8],
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 50,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [12, 25, 15, 40, 40, 10, 30, 15,]
            }
        ]
    };

    const chartData3 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color3)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                categories: [1, 2, 3, 4, 5, 6, 7, 8],
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 50,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [20, 45, 30, 20, 12, 45, 30, 40]
            }
        ]
    };

    return (
        <>
            <Breadcrumb title="Client Detail" path="Clients / Client Detail" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 flex gap-15 flex-wrap mb-30'>
                <img src={userProfile} alt='client' width="140" height="140" className='w-[140px] h-[140px] object-cover' />
                <div>
                    <p className='text-[20px]/[24px] font-medium text-primary mb-5'>
                        Jessica Doe <span className='text-[16px]/[19.2px] font-medium text-yellow'>CEO</span>
                    </p>
                    <p className='text-text-secondary mb-10'>
                        795 Folsom Ave, Suite 600 San Francisco, CADGE 94107
                    </p>
                    <div className='flex items-center gap-15 mb-15'>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandFacebook className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandTwitter className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandInstagram className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandLinkedin className='text-blue w-[18px] h-[18px]' />
                        </Link>
                    </div>
                    <div className='flex gap-5'>
                        <button className='btn btn-primary'>
                            Follow
                        </button>
                        <button className='btn btn-sky'>
                            Message
                        </button>
                    </div>
                </div>
            </div>
            <div className='grid lg:grid-cols-3 grid-cols-1 gap-30'>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='mb-30'>
                        <p className='text-[16px]/[19.2px] font-medium'>
                            DS - Design Team
                        </p>
                        <small>
                            Ranking 2nd
                        </small>
                    </div>
                    <div className='flex items-center justify-between gap-15 mb-15'>
                        <p className='text-[16px]/[19.2px] font-medium'>
                            Info about Design Team
                        </p>
                        <span className='inline-block rounded text-white bg-success py-[3px] px-2 text-[10.5px]/[12px]'>
                            New
                        </span>
                    </div>
                    <p className='mb-15'>
                        It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
                    </p>
                    <div className='flex items-center gap-10 mb-15'>
                        <p className='text-text-secondary'>
                            Team :
                        </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar4} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                    <div title='87%' className='progress h-5 bg-bg-light-100 rounded-lg overflow-hidden mb-15'>
                        <div className="progress-bar w-[87%] h-full bg-primary text-[12px]/[20px] text-white font-medium px-5 flex items-center justify-center"></div>
                    </div>
                    <div className='flex items-center justify-between gap-15'>
                        <div>
                            <p className='text-text-secondary'>
                                PROJECTS : 12
                            </p>
                            <p className='text-[16px]/[19.2px] font-medium text-text-secondary'>
                                BUDGET : 4,870 USD
                            </p>
                        </div>
                        <ReactApexChart options={chartData1.options} series={chartData1.series} type="bar" height={40} width={80} />
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='mb-30'>
                        <p className='text-[16px]/[19.2px] font-medium'>
                            MT - Marketing Team
                        </p>
                        <small>
                            Ranking 4th
                        </small>
                    </div>
                    <div className='flex items-center justify-between gap-15 mb-15'>
                        <p className='text-[16px]/[19.2px] font-medium'>
                            Info about Marketing Team
                        </p>
                    </div>
                    <p className='mb-15'>
                        It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
                    </p>
                    <div className='flex items-center gap-10 mb-15'>
                        <p className='text-text-secondary'>
                            Team :
                        </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                    <div title='54%' className='progress h-5 bg-bg-light-100 rounded-lg overflow-hidden mb-15'>
                        <div className="progress-bar w-[54%] h-full bg-yellow text-[12px]/[20px] text-white font-medium px-5 flex items-center justify-center"></div>
                    </div>
                    <div className='flex items-center justify-between gap-15'>
                        <div>
                            <p className='text-text-secondary'>
                                PROJECTS : 08
                            </p>
                            <p className='text-[16px]/[19.2px] font-medium text-text-secondary'>
                                BUDGET : 2,170 USD
                            </p>
                        </div>
                        <ReactApexChart options={chartData2.options} series={chartData2.series} type="bar" height={40} width={80} />
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='mb-30'>
                        <p className='text-[16px]/[19.2px] font-medium'>
                            DT - Developers Team
                        </p>
                        <small>
                            Ranking 5th
                        </small>
                    </div>
                    <div className='flex items-center justify-between gap-15 mb-15'>
                        <p className='text-[16px]/[19.2px] font-medium'>
                            Info about Developers Team
                        </p>
                    </div>
                    <p className='mb-15'>
                        It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
                    </p>
                    <div className='flex items-center gap-10 mb-15'>
                        <p className='text-text-secondary'>
                            Team :
                        </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Chris Fox' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar4} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Chris Fox' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Chris Fox' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                    <div title='34%' className='progress h-5 bg-bg-light-100 rounded-lg overflow-hidden mb-15'>
                        <div className="progress-bar w-[34%] h-full bg-success text-[12px]/[20px] text-white font-medium px-5 flex items-center justify-center"></div>
                    </div>
                    <div className='flex items-center justify-between gap-15'>
                        <div>
                            <p className='text-text-secondary'>
                                PROJECTS : 23
                            </p>
                            <p className='text-[16px]/[19.2px] font-medium text-text-secondary'>
                                BUDGET : 8,000 USD
                            </p>
                        </div>
                        <ReactApexChart options={chartData3.options} series={chartData3.series} type="bar" height={40} width={80} />
                    </div>
                </div>
            </div>
        </>
    )
}
